'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var statusMsg = require('./side-panel-status-msg');

var addEventHandlers = function() {

	appDom.document.on('click', '.product-detail__add-to-cart-btn', onAddToCartClicked);
	appDom.document.on('click', '.product-detail__update-cart-btn', onUpdateCartClicked);
	appDom.document.on('change', '.product-detail__option', onOptionChanged);

};

var onUpdateCartClicked = function(e) {

	var $btn = $(this);
	var $productForm = $btn.parents('form');
	var serializedFormData = $productForm.serialize();
	var isDisabled = $btn.is('.product-detail__update-cart-btn--is-disabled');

	e.preventDefault();

	if (isDisabled) {
		return;
	}

	$btn.attr('data-original-text', $btn.text()).text(window.pbizServer.content.loading);

	$.ajax({
		url: '?page=update_product_in_cart',
		method: 'POST',
		dataType: 'JSON',
		data: serializedFormData
	}).done(onAddToCartClickedDone);

};

var onAddToCartClicked = function(e) {

	var $btn = $(this);
	var $productForm = $btn.parents('form');
	var serializedFormData = $productForm.serialize();
	var isDisabled = $btn.is('.product-detail__add-to-cart-btn--is-disabled');

	e.preventDefault();

	if (isDisabled) {
		return;
	}

	$btn.attr('data-original-text', $btn.text()).text(window.pbizServer.content.loading);

	$.ajax({
		url: '?page=buy_products_action',
		method: 'POST',
		dataType: 'JSON',
		data: serializedFormData
	}).done(onAddToCartClickedDone);

};

var onAddToCartClickedDone = function(response) {

	var $productForm = $('.product-detail__form');
	var $btn = $('.product-detail__update-cart-btn,.product-detail__add-to-cart-btn');

	if (response.status.code === 1) {

		if ($productForm.attr('data-is-product-in-cart') === 'true') {

			statusMsg.show('cart_updated');

		} else {

			statusMsg.show('added_to_cart');

		}

		$.ajax({
			url: '?page=buy_panel',
			method: 'POST',
			dataType: 'JSON',
			data: {
				activePanel: 'product_images'
			}
		}).done(function(response) {

			sidePanel.open(response.markup);

		});

	} else {

		$btn.text($btn.attr('data-original-text'));

		notify.show({
			target: $('[name="' + response.target + '"]'),
			msg: response.status.msg
		});

	}

};

var onOptionChanged = function() {

	var $selectBox = $(this);
	var $productForm = $selectBox.parents('form');
	var serializedFormData = $productForm.serialize();

	serializedFormData += '&detail=' + $productForm.attr('data-form-detail');

	$.ajax({
		url: '?page=product_detail',
		method: 'POST',
		dataType: 'JSON',
		data: serializedFormData
	}).done(function(response) {

		sidePanel.open(response.markup, {retainScrollPosition: true});

	});

};

// var renderProductDetailPanel = function(addedToCart) {

// 	var $productForm = $('.product-detail__form');

// 	$.ajax({
// 		url: '?page=buy_panel',
// 		method: 'POST',
// 		dataType: 'JSON',
// 		data: {
// 			activePanel: 'product_detail'
// 		}
// 	}).done(function(response) {

// 		sidePanel.open(response.markup);

// 		if (addedToCart) {

// 			if ($productForm.attr('data-is-product-in-cart') === 'true') {

// 				statusMsg.show('cart_updated');

// 			} else {

// 				statusMsg.show('added_to_cart');

// 			}

// 		}

// 	});

// };

var init = function() {

	addEventHandlers();

};

module.exports = {
	init: init
};
